"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var constants_1 = require("@/constants");
var axiosInstance = axios_1.default.create({
    baseURL: "".concat(process.env.BASE_URL, "/api/v1"),
    timeout: 10000,
    headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },
});
var handleRequest = function (config) {
    var TOKEN = localStorage.getItem(constants_1.ACCESS_TOKEN);
    return TOKEN
        ? __assign(__assign({}, config), { headers: __assign(__assign({}, config.headers), { Authorization: "Bearer ".concat(TOKEN) }) }) : config;
};
var handleResponse = function (response) {
    return response.data;
};
var handleError = function (error) {
    if (error instanceof Error) {
        if (axios_1.default.isAxiosError(error)) {
            if (error.response) {
                throw error;
            }
            else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser
                throw new Error(error);
            }
        }
        else {
            // Something happened in setting up the request that triggered an Error
            throw new Error(error.message);
        }
    }
    throw new Error(error);
};
var createApiMethod = function (_axiosInstance, methodType) {
    return function (config) {
        return _axiosInstance(__assign(__assign({}, handleRequest(config)), { method: methodType }))
            .then(handleResponse)
            .catch(handleError);
    };
};
exports.default = {
    get: createApiMethod(axiosInstance, constants_1.HTTP_METHODS.GET),
    post: createApiMethod(axiosInstance, constants_1.HTTP_METHODS.POST),
    patch: createApiMethod(axiosInstance, constants_1.HTTP_METHODS.PATCH),
    put: createApiMethod(axiosInstance, constants_1.HTTP_METHODS.PUT),
    delete: createApiMethod(axiosInstance, constants_1.HTTP_METHODS.DELETE),
};
